/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ArchiveWorkOrdersDto,
  ArchiveWorkOrdersResultDto,
  BatchAddWorkOrdersDto,
  BatchRemoveWorkOrdersDto,
  BatchUpdateWorkOrdersDto,
  CommitDraftDatesDto,
  CommitDraftDatesResultDto,
  CommitPullDraftDatesDto,
  CommitPullDraftDatesResultDto,
  CreateProjectPlanningDto,
  DraftDatesPreviewDto,
  PreviewProjectManufacturingSequenceDto,
  ProjectLaborShiftSummaryDto,
  ProjectManufacturingSequencePreviewDto,
  ProjectManufacturingSequenceResultDto,
  ProjectPlanningControllerGetProjectPlanningParams,
  ProjectPlanningControllerListProjectsPlanningParams,
  ProjectPlanningControllerPreviewDraftDatesParams,
  ProjectPlanningControllerPreviewPullDraftDatesParams,
  ProjectPlanningDetailDto,
  ProjectPlanningListItemDto,
  ProjectWorkOrderDetailDto,
  PullDraftDatesPreviewDto,
  RedraftProjectDto,
  ReleaseRoutePreviewDto,
  UnarchiveWorkOrdersDto,
  UnarchiveWorkOrdersResultDto,
  UpdateProjectColumnConfigDto,
  UpdateProjectManufacturingSequenceDto,
  UpdateProjectPlanningDto
} from '../schemas';

import { customFetch } from '../../custom-fetch.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type projectPlanningControllerListProjectsPlanningResponse200 = {
  data: ProjectPlanningListItemDto[]
  status: 200
}

export type projectPlanningControllerListProjectsPlanningResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerListProjectsPlanningResponse403 = {
  data: void
  status: 403
}

export type projectPlanningControllerListProjectsPlanningResponseSuccess = (projectPlanningControllerListProjectsPlanningResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerListProjectsPlanningResponseError = (projectPlanningControllerListProjectsPlanningResponse401 | projectPlanningControllerListProjectsPlanningResponse403) & {
  headers: Headers;
};

export type projectPlanningControllerListProjectsPlanningResponse = (projectPlanningControllerListProjectsPlanningResponseSuccess | projectPlanningControllerListProjectsPlanningResponseError)

export const getProjectPlanningControllerListProjectsPlanningUrl = (params: ProjectPlanningControllerListProjectsPlanningParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/projects/planning?${stringifiedParams}` : `/projects/planning`
}

/**
 * Returns every project for the given partner, archived ones included (is_archived / archived_at), with planning status (draft/released/redrafting), distinct factory names, and work order counts, including the non-draft count that decides whether a project can be archived (ENG-981). Active projects come first, then by creation date descending. Callers must be a member of the requested partner (admins bypass this check).
 * @summary List projects for a partner with planning info
 */
export const projectPlanningControllerListProjectsPlanning = async (params: ProjectPlanningControllerListProjectsPlanningParams, options?: Parameters<typeof customFetch>[1]): Promise<projectPlanningControllerListProjectsPlanningResponse> => {

  return customFetch<projectPlanningControllerListProjectsPlanningResponse>(getProjectPlanningControllerListProjectsPlanningUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProjectPlanningControllerListProjectsPlanningQueryKey = (params?: ProjectPlanningControllerListProjectsPlanningParams,) => {
    return [
    `/projects/planning`, ...(params ? [params] : [])
    ] as const;
    }


export const getProjectPlanningControllerListProjectsPlanningQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerListProjectsPlanningQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>> = ({ signal }) => projectPlanningControllerListProjectsPlanning(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectPlanningControllerListProjectsPlanningQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>>
export type ProjectPlanningControllerListProjectsPlanningQueryError = void


export function useProjectPlanningControllerListProjectsPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerListProjectsPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerListProjectsPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List projects for a partner with planning info
 */

export function useProjectPlanningControllerListProjectsPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectPlanningControllerListProjectsPlanningQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List projects for a partner with planning info
 */
export const prefetchProjectPlanningControllerListProjectsPlanningQuery = async <TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 queryClient: QueryClient, params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getProjectPlanningControllerListProjectsPlanningQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getProjectPlanningControllerListProjectsPlanningSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerListProjectsPlanningQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>> = ({ signal }) => projectPlanningControllerListProjectsPlanning(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectPlanningControllerListProjectsPlanningSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>>
export type ProjectPlanningControllerListProjectsPlanningSuspenseQueryError = void


export function useProjectPlanningControllerListProjectsPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerListProjectsPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerListProjectsPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List projects for a partner with planning info
 */

export function useProjectPlanningControllerListProjectsPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectPlanningControllerListProjectsPlanningSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type projectPlanningControllerCreateProjectPlanningResponse201 = {
  data: ProjectPlanningListItemDto
  status: 201
}

export type projectPlanningControllerCreateProjectPlanningResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerCreateProjectPlanningResponse403 = {
  data: void
  status: 403
}

export type projectPlanningControllerCreateProjectPlanningResponseSuccess = (projectPlanningControllerCreateProjectPlanningResponse201) & {
  headers: Headers;
};
export type projectPlanningControllerCreateProjectPlanningResponseError = (projectPlanningControllerCreateProjectPlanningResponse401 | projectPlanningControllerCreateProjectPlanningResponse403) & {
  headers: Headers;
};

export type projectPlanningControllerCreateProjectPlanningResponse = (projectPlanningControllerCreateProjectPlanningResponseSuccess | projectPlanningControllerCreateProjectPlanningResponseError)

export const getProjectPlanningControllerCreateProjectPlanningUrl = () => {




  return `/projects/planning`
}

/**
 * Creates a new project in draft status under the given partner. Used by the new Production Planning UI. Mirrors the admin-only event-sourced `POST /projects` but is gated by PartnerAccessGuard and forces project_status = "draft" so new projects start in the planning workflow.
 * @summary Create a project (cookie-auth)
 */
export const projectPlanningControllerCreateProjectPlanning = async (createProjectPlanningDto: CreateProjectPlanningDto, options?: Parameters<typeof customFetch>[1]): Promise<projectPlanningControllerCreateProjectPlanningResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<projectPlanningControllerCreateProjectPlanningResponse>(getProjectPlanningControllerCreateProjectPlanningUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createProjectPlanningDto)
  }
);}





export const getProjectPlanningControllerCreateProjectPlanningMutationKey = () => ['projectPlanningControllerCreateProjectPlanning'] as const;

export const getProjectPlanningControllerCreateProjectPlanningMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerCreateProjectPlanning>>, TError,ProjectPlanningControllerCreateProjectPlanningMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerCreateProjectPlanning>>, TError,ProjectPlanningControllerCreateProjectPlanningMutationVariables, TContext> => {

const mutationKey = getProjectPlanningControllerCreateProjectPlanningMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerCreateProjectPlanning>>, ProjectPlanningControllerCreateProjectPlanningMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  projectPlanningControllerCreateProjectPlanning(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerCreateProjectPlanningMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerCreateProjectPlanning>>>
    export type ProjectPlanningControllerCreateProjectPlanningMutationBody = CreateProjectPlanningDto
    export type ProjectPlanningControllerCreateProjectPlanningMutationError = void
    export type ProjectPlanningControllerCreateProjectPlanningMutationVariables = {data: CreateProjectPlanningDto}

    /**
 * @summary Create a project (cookie-auth)
 */
export const useProjectPlanningControllerCreateProjectPlanning = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerCreateProjectPlanning>>, TError,ProjectPlanningControllerCreateProjectPlanningMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerCreateProjectPlanning>>,
        TError,
        ProjectPlanningControllerCreateProjectPlanningMutationVariables,
        TContext
      > => {
      return useMutation(getProjectPlanningControllerCreateProjectPlanningMutationOptions(options), queryClient);
    }
    export type projectPlanningControllerGetProjectPlanningResponse200 = {
  data: ProjectPlanningDetailDto
  status: 200
}

export type projectPlanningControllerGetProjectPlanningResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerGetProjectPlanningResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerGetProjectPlanningResponseSuccess = (projectPlanningControllerGetProjectPlanningResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerGetProjectPlanningResponseError = (projectPlanningControllerGetProjectPlanningResponse401 | projectPlanningControllerGetProjectPlanningResponse404) & {
  headers: Headers;
};

export type projectPlanningControllerGetProjectPlanningResponse = (projectPlanningControllerGetProjectPlanningResponseSuccess | projectPlanningControllerGetProjectPlanningResponseError)

export const getProjectPlanningControllerGetProjectPlanningUrl = (projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/projects/${projectId}/planning?${stringifiedParams}` : `/projects/${projectId}/planning`
}

/**
 * Returns a project with planning metadata and its work orders (with container selections, product keys, and metadata).
 * @summary Get project planning detail
 */
export const projectPlanningControllerGetProjectPlanning = async (projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: Parameters<typeof customFetch>[1]): Promise<projectPlanningControllerGetProjectPlanningResponse> => {

  return customFetch<projectPlanningControllerGetProjectPlanningResponse>(getProjectPlanningControllerGetProjectPlanningUrl(projectId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProjectPlanningControllerGetProjectPlanningQueryKey = (projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams,) => {
    return [
    `/projects/${projectId}/planning`, ...(params ? [params] : [])
    ] as const;
    }


export const getProjectPlanningControllerGetProjectPlanningQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerGetProjectPlanningQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>> = ({ signal }) => projectPlanningControllerGetProjectPlanning(projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectPlanningControllerGetProjectPlanningQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>>
export type ProjectPlanningControllerGetProjectPlanningQueryError = void


export function useProjectPlanningControllerGetProjectPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params: undefined |  ProjectPlanningControllerGetProjectPlanningParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerGetProjectPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerGetProjectPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project planning detail
 */

export function useProjectPlanningControllerGetProjectPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectPlanningControllerGetProjectPlanningQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get project planning detail
 */
export const prefetchProjectPlanningControllerGetProjectPlanningQuery = async <TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 queryClient: QueryClient, projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getProjectPlanningControllerGetProjectPlanningQueryOptions(projectId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getProjectPlanningControllerGetProjectPlanningSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerGetProjectPlanningQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>> = ({ signal }) => projectPlanningControllerGetProjectPlanning(projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectPlanningControllerGetProjectPlanningSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>>
export type ProjectPlanningControllerGetProjectPlanningSuspenseQueryError = void


export function useProjectPlanningControllerGetProjectPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params: undefined |  ProjectPlanningControllerGetProjectPlanningParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerGetProjectPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerGetProjectPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project planning detail
 */

export function useProjectPlanningControllerGetProjectPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectPlanningControllerGetProjectPlanningSuspenseQueryOptions(projectId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type projectPlanningControllerUpdateProjectPlanningResponse200 = {
  data: ProjectPlanningDetailDto
  status: 200
}

export type projectPlanningControllerUpdateProjectPlanningResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerUpdateProjectPlanningResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerUpdateProjectPlanningResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerUpdateProjectPlanningResponse409 = {
  data: void
  status: 409
}

export type projectPlanningControllerUpdateProjectPlanningResponseSuccess = (projectPlanningControllerUpdateProjectPlanningResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerUpdateProjectPlanningResponseError = (projectPlanningControllerUpdateProjectPlanningResponse400 | projectPlanningControllerUpdateProjectPlanningResponse401 | projectPlanningControllerUpdateProjectPlanningResponse404 | projectPlanningControllerUpdateProjectPlanningResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerUpdateProjectPlanningResponse = (projectPlanningControllerUpdateProjectPlanningResponseSuccess | projectPlanningControllerUpdateProjectPlanningResponseError)

export const getProjectPlanningControllerUpdateProjectPlanningUrl = (projectId: string,) => {




  return `/projects/${projectId}/planning`
}

/**
 * Cookie-auth entry point that updates project metadata (name, code, prefix, dates) via the existing event-sourced ProjectsService. Rejects with 409 unless project_status is "draft" or "redrafting", or when the project is archived. The hub-side admin PATCH at /projects/:project_id is untouched.
 * @summary Update project metadata (cookie-auth)
 */
export const projectPlanningControllerUpdateProjectPlanning = async (projectId: string,
    updateProjectPlanningDto: UpdateProjectPlanningDto, options?: Parameters<typeof customFetch>[1]): Promise<projectPlanningControllerUpdateProjectPlanningResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<projectPlanningControllerUpdateProjectPlanningResponse>(getProjectPlanningControllerUpdateProjectPlanningUrl(projectId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateProjectPlanningDto)
  }
);}





export const getProjectPlanningControllerUpdateProjectPlanningMutationKey = () => ['projectPlanningControllerUpdateProjectPlanning'] as const;

export const getProjectPlanningControllerUpdateProjectPlanningMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectPlanning>>, TError,ProjectPlanningControllerUpdateProjectPlanningMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectPlanning>>, TError,ProjectPlanningControllerUpdateProjectPlanningMutationVariables, TContext> => {

const mutationKey = getProjectPlanningControllerUpdateProjectPlanningMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectPlanning>>, ProjectPlanningControllerUpdateProjectPlanningMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerUpdateProjectPlanning(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerUpdateProjectPlanningMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectPlanning>>>
    export type ProjectPlanningControllerUpdateProjectPlanningMutationBody = UpdateProjectPlanningDto
    export type ProjectPlanningControllerUpdateProjectPlanningMutationError = void
    export type ProjectPlanningControllerUpdateProjectPlanningMutationVariables = {projectId: string;data: UpdateProjectPlanningDto}

    /**
 * @summary Update project metadata (cookie-auth)
 */
export const useProjectPlanningControllerUpdateProjectPlanning = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectPlanning>>, TError,ProjectPlanningControllerUpdateProjectPlanningMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectPlanning>>,
        TError,
        ProjectPlanningControllerUpdateProjectPlanningMutationVariables,
        TContext
      > => {
      return useMutation(getProjectPlanningControllerUpdateProjectPlanningMutationOptions(options), queryClient);
    }
    export type projectPlanningControllerGetProjectLaborShiftSummaryResponse200 = {
  data: ProjectLaborShiftSummaryDto
  status: 200
}

export type projectPlanningControllerGetProjectLaborShiftSummaryResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerGetProjectLaborShiftSummaryResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerGetProjectLaborShiftSummaryResponseSuccess = (projectPlanningControllerGetProjectLaborShiftSummaryResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerGetProjectLaborShiftSummaryResponseError = (projectPlanningControllerGetProjectLaborShiftSummaryResponse401 | projectPlanningControllerGetProjectLaborShiftSummaryResponse404) & {
  headers: Headers;
};

export type projectPlanningControllerGetProjectLaborShiftSummaryResponse = (projectPlanningControllerGetProjectLaborShiftSummaryResponseSuccess | projectPlanningControllerGetProjectLaborShiftSummaryResponseError)

export const getProjectPlanningControllerGetProjectLaborShiftSummaryUrl = (projectId: string,) => {




  return `/projects/${projectId}/labor-shift-summary`
}

/**
 * Calculates Total Labor Shifts and per-factory Headcount per Shift from active work-order value-adding hours, effective shift calendars, and the factory's value-adding efficiency (typed Workforce Efficiency as the fallback).
 * @summary Get project labor shift summary
 */
export const projectPlanningControllerGetProjectLaborShiftSummary = async (projectId: string, options?: Parameters<typeof customFetch>[1]): Promise<projectPlanningControllerGetProjectLaborShiftSummaryResponse> => {

  return customFetch<projectPlanningControllerGetProjectLaborShiftSummaryResponse>(getProjectPlanningControllerGetProjectLaborShiftSummaryUrl(projectId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProjectPlanningControllerGetProjectLaborShiftSummaryQueryKey = (projectId: string,) => {
    return [
    `/projects/${projectId}/labor-shift-summary`
    ] as const;
    }


export const getProjectPlanningControllerGetProjectLaborShiftSummaryQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError = void>(projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerGetProjectLaborShiftSummaryQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>> = ({ signal }) => projectPlanningControllerGetProjectLaborShiftSummary(projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectPlanningControllerGetProjectLaborShiftSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>>
export type ProjectPlanningControllerGetProjectLaborShiftSummaryQueryError = void


export function useProjectPlanningControllerGetProjectLaborShiftSummary<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError = void>(
 projectId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerGetProjectLaborShiftSummary<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError = void>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerGetProjectLaborShiftSummary<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError = void>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project labor shift summary
 */

export function useProjectPlanningControllerGetProjectLaborShiftSummary<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError = void>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectPlanningControllerGetProjectLaborShiftSummaryQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get project labor shift summary
 */
export const prefetchProjectPlanningControllerGetProjectLaborShiftSummaryQuery = async <TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError = void>(
 queryClient: QueryClient, projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getProjectPlanningControllerGetProjectLaborShiftSummaryQueryOptions(projectId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getProjectPlanningControllerGetProjectLaborShiftSummarySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError = void>(projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerGetProjectLaborShiftSummaryQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>> = ({ signal }) => projectPlanningControllerGetProjectLaborShiftSummary(projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectPlanningControllerGetProjectLaborShiftSummarySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>>
export type ProjectPlanningControllerGetProjectLaborShiftSummarySuspenseQueryError = void


export function useProjectPlanningControllerGetProjectLaborShiftSummarySuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError = void>(
 projectId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerGetProjectLaborShiftSummarySuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError = void>(
 projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerGetProjectLaborShiftSummarySuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError = void>(
 projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project labor shift summary
 */

export function useProjectPlanningControllerGetProjectLaborShiftSummarySuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError = void>(
 projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectLaborShiftSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectPlanningControllerGetProjectLaborShiftSummarySuspenseQueryOptions(projectId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type projectPlanningControllerUpdateProjectColumnConfigResponse200 = {
  data: ProjectPlanningDetailDto
  status: 200
}

export type projectPlanningControllerUpdateProjectColumnConfigResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerUpdateProjectColumnConfigResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerUpdateProjectColumnConfigResponse409 = {
  data: void
  status: 409
}

export type projectPlanningControllerUpdateProjectColumnConfigResponseSuccess = (projectPlanningControllerUpdateProjectColumnConfigResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerUpdateProjectColumnConfigResponseError = (projectPlanningControllerUpdateProjectColumnConfigResponse401 | projectPlanningControllerUpdateProjectColumnConfigResponse404 | projectPlanningControllerUpdateProjectColumnConfigResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerUpdateProjectColumnConfigResponse = (projectPlanningControllerUpdateProjectColumnConfigResponseSuccess | projectPlanningControllerUpdateProjectColumnConfigResponseError)

export const getProjectPlanningControllerUpdateProjectColumnConfigUrl = (projectId: string,) => {




  return `/projects/${projectId}/column-config`
}

/**
 * Persists the AG Grid column state (visibility, order, pinning, width) for the project planning grid. Shared across all users at the partner and reapplied on page load. Allowed on any project status — column layout is presentational and never affects work-order data. Optimistic concurrency: the client passes the project_column_config_updated_at value from its last GET; the server returns 409 if another user has saved in between.
 * @summary Update project planning grid column layout
 */
export const projectPlanningControllerUpdateProjectColumnConfig = async (projectId: string,
    updateProjectColumnConfigDto: UpdateProjectColumnConfigDto, options?: Parameters<typeof customFetch>[1]): Promise<projectPlanningControllerUpdateProjectColumnConfigResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<projectPlanningControllerUpdateProjectColumnConfigResponse>(getProjectPlanningControllerUpdateProjectColumnConfigUrl(projectId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateProjectColumnConfigDto)
  }
);}





export const getProjectPlanningControllerUpdateProjectColumnConfigMutationKey = () => ['projectPlanningControllerUpdateProjectColumnConfig'] as const;

export const getProjectPlanningControllerUpdateProjectColumnConfigMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectColumnConfig>>, TError,ProjectPlanningControllerUpdateProjectColumnConfigMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectColumnConfig>>, TError,ProjectPlanningControllerUpdateProjectColumnConfigMutationVariables, TContext> => {

const mutationKey = getProjectPlanningControllerUpdateProjectColumnConfigMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectColumnConfig>>, ProjectPlanningControllerUpdateProjectColumnConfigMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerUpdateProjectColumnConfig(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerUpdateProjectColumnConfigMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectColumnConfig>>>
    export type ProjectPlanningControllerUpdateProjectColumnConfigMutationBody = UpdateProjectColumnConfigDto
    export type ProjectPlanningControllerUpdateProjectColumnConfigMutationError = void
    export type ProjectPlanningControllerUpdateProjectColumnConfigMutationVariables = {projectId: string;data: UpdateProjectColumnConfigDto}

    /**
 * @summary Update project planning grid column layout
 */
export const useProjectPlanningControllerUpdateProjectColumnConfig = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectColumnConfig>>, TError,ProjectPlanningControllerUpdateProjectColumnConfigMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectColumnConfig>>,
        TError,
        ProjectPlanningControllerUpdateProjectColumnConfigMutationVariables,
        TContext
      > => {
      return useMutation(getProjectPlanningControllerUpdateProjectColumnConfigMutationOptions(options), queryClient);
    }
    export type projectPlanningControllerPreviewReleaseRoutesResponse200 = {
  data: ReleaseRoutePreviewDto
  status: 200
}

export type projectPlanningControllerPreviewReleaseRoutesResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerPreviewReleaseRoutesResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerPreviewReleaseRoutesResponseSuccess = (projectPlanningControllerPreviewReleaseRoutesResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerPreviewReleaseRoutesResponseError = (projectPlanningControllerPreviewReleaseRoutesResponse401 | projectPlanningControllerPreviewReleaseRoutesResponse404) & {
  headers: Headers;
};

export type projectPlanningControllerPreviewReleaseRoutesResponse = (projectPlanningControllerPreviewReleaseRoutesResponseSuccess | projectPlanningControllerPreviewReleaseRoutesResponseError)

export const getProjectPlanningControllerPreviewReleaseRoutesUrl = (projectId: string,) => {




  return `/projects/${projectId}/release-route-preview`
}

/**
 * ENG-822 §12.5: the work orders that would release with no route because their factory's default route cannot build their product type, grouped by product for the Stage 4 release warning. Read-only — it never creates a default route, and a factory with no default yet is reported as assignable because release auto-creates an unscoped default for it. Returns an empty preview when the routing flag is not active for the caller. Release is never blocked by this (§12.2); the affected work orders land in the Missing Routes count and are fixed with Set Route on the Production Plan.
 * @summary Preview which work orders will release without a route
 */
export const projectPlanningControllerPreviewReleaseRoutes = async (projectId: string, options?: Parameters<typeof customFetch>[1]): Promise<projectPlanningControllerPreviewReleaseRoutesResponse> => {

  return customFetch<projectPlanningControllerPreviewReleaseRoutesResponse>(getProjectPlanningControllerPreviewReleaseRoutesUrl(projectId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProjectPlanningControllerPreviewReleaseRoutesQueryKey = (projectId: string,) => {
    return [
    `/projects/${projectId}/release-route-preview`
    ] as const;
    }


export const getProjectPlanningControllerPreviewReleaseRoutesQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError = void>(projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerPreviewReleaseRoutesQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>> = ({ signal }) => projectPlanningControllerPreviewReleaseRoutes(projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectPlanningControllerPreviewReleaseRoutesQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>>
export type ProjectPlanningControllerPreviewReleaseRoutesQueryError = void


export function useProjectPlanningControllerPreviewReleaseRoutes<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError = void>(
 projectId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerPreviewReleaseRoutes<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError = void>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerPreviewReleaseRoutes<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError = void>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview which work orders will release without a route
 */

export function useProjectPlanningControllerPreviewReleaseRoutes<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError = void>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectPlanningControllerPreviewReleaseRoutesQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Preview which work orders will release without a route
 */
export const prefetchProjectPlanningControllerPreviewReleaseRoutesQuery = async <TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError = void>(
 queryClient: QueryClient, projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getProjectPlanningControllerPreviewReleaseRoutesQueryOptions(projectId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getProjectPlanningControllerPreviewReleaseRoutesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError = void>(projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerPreviewReleaseRoutesQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>> = ({ signal }) => projectPlanningControllerPreviewReleaseRoutes(projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectPlanningControllerPreviewReleaseRoutesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>>
export type ProjectPlanningControllerPreviewReleaseRoutesSuspenseQueryError = void


export function useProjectPlanningControllerPreviewReleaseRoutesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError = void>(
 projectId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerPreviewReleaseRoutesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError = void>(
 projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerPreviewReleaseRoutesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError = void>(
 projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview which work orders will release without a route
 */

export function useProjectPlanningControllerPreviewReleaseRoutesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError = void>(
 projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectPlanningControllerPreviewReleaseRoutesSuspenseQueryOptions(projectId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type projectPlanningControllerReleaseProjectResponse200 = {
  data: ProjectPlanningDetailDto
  status: 200
}

export type projectPlanningControllerReleaseProjectResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerReleaseProjectResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerReleaseProjectResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerReleaseProjectResponse409 = {
  data: void
  status: 409
}

export type projectPlanningControllerReleaseProjectResponseSuccess = (projectPlanningControllerReleaseProjectResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerReleaseProjectResponseError = (projectPlanningControllerReleaseProjectResponse400 | projectPlanningControllerReleaseProjectResponse401 | projectPlanningControllerReleaseProjectResponse404 | projectPlanningControllerReleaseProjectResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerReleaseProjectResponse = (projectPlanningControllerReleaseProjectResponseSuccess | projectPlanningControllerReleaseProjectResponseError)

export const getProjectPlanningControllerReleaseProjectUrl = (projectId: string,) => {




  return `/projects/${projectId}/release`
}

/**
 * Transitions a draft project to released status. Assigns the current Run Sheet version to every draft work order and flips them to "scheduled" status. Sets project_released_by and project_released_at. Rejects with 409 if not in draft status, or 400 if any work order is missing a required container selection or any draft work order is on an archived factory.
 * @summary Release a project
 */
export const projectPlanningControllerReleaseProject = async (projectId: string, options?: Parameters<typeof customFetch>[1]): Promise<projectPlanningControllerReleaseProjectResponse> => {

  return customFetch<projectPlanningControllerReleaseProjectResponse>(getProjectPlanningControllerReleaseProjectUrl(projectId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getProjectPlanningControllerReleaseProjectMutationKey = () => ['projectPlanningControllerReleaseProject'] as const;

export const getProjectPlanningControllerReleaseProjectMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerReleaseProject>>, TError,ProjectPlanningControllerReleaseProjectMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerReleaseProject>>, TError,ProjectPlanningControllerReleaseProjectMutationVariables, TContext> => {

const mutationKey = getProjectPlanningControllerReleaseProjectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerReleaseProject>>, ProjectPlanningControllerReleaseProjectMutationVariables> = (props) => {
          const {projectId} = props ?? {};

          return  projectPlanningControllerReleaseProject(projectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerReleaseProjectMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerReleaseProject>>>

    export type ProjectPlanningControllerReleaseProjectMutationError = void
    export type ProjectPlanningControllerReleaseProjectMutationVariables = {projectId: string}

    /**
 * @summary Release a project
 */
export const useProjectPlanningControllerReleaseProject = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerReleaseProject>>, TError,ProjectPlanningControllerReleaseProjectMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerReleaseProject>>,
        TError,
        ProjectPlanningControllerReleaseProjectMutationVariables,
        TContext
      > => {
      return useMutation(getProjectPlanningControllerReleaseProjectMutationOptions(options), queryClient);
    }
    export type projectPlanningControllerReleaseDraftWorkOrdersResponse200 = {
  data: ProjectPlanningDetailDto
  status: 200
}

export type projectPlanningControllerReleaseDraftWorkOrdersResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerReleaseDraftWorkOrdersResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerReleaseDraftWorkOrdersResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerReleaseDraftWorkOrdersResponse409 = {
  data: void
  status: 409
}

export type projectPlanningControllerReleaseDraftWorkOrdersResponseSuccess = (projectPlanningControllerReleaseDraftWorkOrdersResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerReleaseDraftWorkOrdersResponseError = (projectPlanningControllerReleaseDraftWorkOrdersResponse400 | projectPlanningControllerReleaseDraftWorkOrdersResponse401 | projectPlanningControllerReleaseDraftWorkOrdersResponse404 | projectPlanningControllerReleaseDraftWorkOrdersResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerReleaseDraftWorkOrdersResponse = (projectPlanningControllerReleaseDraftWorkOrdersResponseSuccess | projectPlanningControllerReleaseDraftWorkOrdersResponseError)

export const getProjectPlanningControllerReleaseDraftWorkOrdersUrl = (projectId: string,) => {




  return `/projects/${projectId}/release-drafts`
}

/**
 * Releases the work orders still in "draft" on an already-released or redrafting project — the rows added during a redraft cycle. Assigns the current Run Sheet, renumbers each factory's Manufacturing Sequence, and flips them "draft" → "scheduled". A "redrafting" project returns to "released" once no draft or redrafting rows remain; a row the reconcile leaves in "draft" (no Run Sheet) keeps it open. Used by the re-release flow. Rejects with 409 if the project is still in draft status, or 400 (MISSING_REQUIRED_FIELDS) if any draft work order is missing a required field or is on an archived factory.
 * @summary Release draft work orders on a redrafting project
 */
export const projectPlanningControllerReleaseDraftWorkOrders = async (projectId: string, options?: Parameters<typeof customFetch>[1]): Promise<projectPlanningControllerReleaseDraftWorkOrdersResponse> => {

  return customFetch<projectPlanningControllerReleaseDraftWorkOrdersResponse>(getProjectPlanningControllerReleaseDraftWorkOrdersUrl(projectId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getProjectPlanningControllerReleaseDraftWorkOrdersMutationKey = () => ['projectPlanningControllerReleaseDraftWorkOrders'] as const;

export const getProjectPlanningControllerReleaseDraftWorkOrdersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerReleaseDraftWorkOrders>>, TError,ProjectPlanningControllerReleaseDraftWorkOrdersMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerReleaseDraftWorkOrders>>, TError,ProjectPlanningControllerReleaseDraftWorkOrdersMutationVariables, TContext> => {

const mutationKey = getProjectPlanningControllerReleaseDraftWorkOrdersMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerReleaseDraftWorkOrders>>, ProjectPlanningControllerReleaseDraftWorkOrdersMutationVariables> = (props) => {
          const {projectId} = props ?? {};

          return  projectPlanningControllerReleaseDraftWorkOrders(projectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerReleaseDraftWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerReleaseDraftWorkOrders>>>

    export type ProjectPlanningControllerReleaseDraftWorkOrdersMutationError = void
    export type ProjectPlanningControllerReleaseDraftWorkOrdersMutationVariables = {projectId: string}

    /**
 * @summary Release draft work orders on a redrafting project
 */
export const useProjectPlanningControllerReleaseDraftWorkOrders = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerReleaseDraftWorkOrders>>, TError,ProjectPlanningControllerReleaseDraftWorkOrdersMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerReleaseDraftWorkOrders>>,
        TError,
        ProjectPlanningControllerReleaseDraftWorkOrdersMutationVariables,
        TContext
      > => {
      return useMutation(getProjectPlanningControllerReleaseDraftWorkOrdersMutationOptions(options), queryClient);
    }
    export type projectPlanningControllerMoveProjectToDraftResponse200 = {
  data: ProjectPlanningDetailDto
  status: 200
}

export type projectPlanningControllerMoveProjectToDraftResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerMoveProjectToDraftResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerMoveProjectToDraftResponse409 = {
  data: void
  status: 409
}

export type projectPlanningControllerMoveProjectToDraftResponseSuccess = (projectPlanningControllerMoveProjectToDraftResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerMoveProjectToDraftResponseError = (projectPlanningControllerMoveProjectToDraftResponse401 | projectPlanningControllerMoveProjectToDraftResponse404 | projectPlanningControllerMoveProjectToDraftResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerMoveProjectToDraftResponse = (projectPlanningControllerMoveProjectToDraftResponseSuccess | projectPlanningControllerMoveProjectToDraftResponseError)

export const getProjectPlanningControllerMoveProjectToDraftUrl = (projectId: string,) => {




  return `/projects/${projectId}/move-to-draft`
}

/**
 * Moves a released project back to draft. Only work orders still in "scheduled" status revert to "draft"; work orders already "in_progress" or "complete" are left untouched. Returns 409 if the project is not in released status.
 * @summary Move a released project back to draft
 */
export const projectPlanningControllerMoveProjectToDraft = async (projectId: string, options?: Parameters<typeof customFetch>[1]): Promise<projectPlanningControllerMoveProjectToDraftResponse> => {

  return customFetch<projectPlanningControllerMoveProjectToDraftResponse>(getProjectPlanningControllerMoveProjectToDraftUrl(projectId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getProjectPlanningControllerMoveProjectToDraftMutationKey = () => ['projectPlanningControllerMoveProjectToDraft'] as const;

export const getProjectPlanningControllerMoveProjectToDraftMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerMoveProjectToDraft>>, TError,ProjectPlanningControllerMoveProjectToDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerMoveProjectToDraft>>, TError,ProjectPlanningControllerMoveProjectToDraftMutationVariables, TContext> => {

const mutationKey = getProjectPlanningControllerMoveProjectToDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerMoveProjectToDraft>>, ProjectPlanningControllerMoveProjectToDraftMutationVariables> = (props) => {
          const {projectId} = props ?? {};

          return  projectPlanningControllerMoveProjectToDraft(projectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerMoveProjectToDraftMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerMoveProjectToDraft>>>

    export type ProjectPlanningControllerMoveProjectToDraftMutationError = void
    export type ProjectPlanningControllerMoveProjectToDraftMutationVariables = {projectId: string}

    /**
 * @summary Move a released project back to draft
 */
export const useProjectPlanningControllerMoveProjectToDraft = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerMoveProjectToDraft>>, TError,ProjectPlanningControllerMoveProjectToDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerMoveProjectToDraft>>,
        TError,
        ProjectPlanningControllerMoveProjectToDraftMutationVariables,
        TContext
      > => {
      return useMutation(getProjectPlanningControllerMoveProjectToDraftMutationOptions(options), queryClient);
    }
    export type projectPlanningControllerRedraftProjectResponse200 = {
  data: ProjectPlanningDetailDto
  status: 200
}

export type projectPlanningControllerRedraftProjectResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerRedraftProjectResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerRedraftProjectResponse409 = {
  data: void
  status: 409
}

export type projectPlanningControllerRedraftProjectResponseSuccess = (projectPlanningControllerRedraftProjectResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerRedraftProjectResponseError = (projectPlanningControllerRedraftProjectResponse401 | projectPlanningControllerRedraftProjectResponse404 | projectPlanningControllerRedraftProjectResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerRedraftProjectResponse = (projectPlanningControllerRedraftProjectResponseSuccess | projectPlanningControllerRedraftProjectResponseError)

export const getProjectPlanningControllerRedraftProjectUrl = (projectId: string,) => {




  return `/projects/${projectId}/redraft`
}

/**
 * Reopens a released project for edits by setting project_status to "redrafting" — unconditionally, even when the project has nothing eligible to reopen (an empty project, or one where every work order is archived, in_progress, or complete). This is what lets new work orders be added to a released project again, manually or via import. Optionally reopens a subset of the project's own eligible `scheduled` rows to `redrafting` in the same call: omit work_order_ids to reopen every eligible row, or pass an explicit empty array to flip project_status only and reopen none. Any requested id that is not one of the project's own eligible scheduled rows is silently ignored. Calling this on an already-redrafting project is allowed (the status write is a no-op) and can still reopen additional rows. Rejects with 409 if the project is still draft — nothing has ever been released to reopen.
 * @summary Redraft a released project (ENG-830)
 */
export const projectPlanningControllerRedraftProject = async (projectId: string,
    redraftProjectDto: RedraftProjectDto, options?: Parameters<typeof customFetch>[1]): Promise<projectPlanningControllerRedraftProjectResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<projectPlanningControllerRedraftProjectResponse>(getProjectPlanningControllerRedraftProjectUrl(projectId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(redraftProjectDto)
  }
);}





export const getProjectPlanningControllerRedraftProjectMutationKey = () => ['projectPlanningControllerRedraftProject'] as const;

export const getProjectPlanningControllerRedraftProjectMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerRedraftProject>>, TError,ProjectPlanningControllerRedraftProjectMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerRedraftProject>>, TError,ProjectPlanningControllerRedraftProjectMutationVariables, TContext> => {

const mutationKey = getProjectPlanningControllerRedraftProjectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerRedraftProject>>, ProjectPlanningControllerRedraftProjectMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerRedraftProject(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerRedraftProjectMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerRedraftProject>>>
    export type ProjectPlanningControllerRedraftProjectMutationBody = RedraftProjectDto
    export type ProjectPlanningControllerRedraftProjectMutationError = void
    export type ProjectPlanningControllerRedraftProjectMutationVariables = {projectId: string;data: RedraftProjectDto}

    /**
 * @summary Redraft a released project (ENG-830)
 */
export const useProjectPlanningControllerRedraftProject = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerRedraftProject>>, TError,ProjectPlanningControllerRedraftProjectMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerRedraftProject>>,
        TError,
        ProjectPlanningControllerRedraftProjectMutationVariables,
        TContext
      > => {
      return useMutation(getProjectPlanningControllerRedraftProjectMutationOptions(options), queryClient);
    }
    export type projectPlanningControllerPreviewDraftDatesResponse200 = {
  data: DraftDatesPreviewDto
  status: 200
}

export type projectPlanningControllerPreviewDraftDatesResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerPreviewDraftDatesResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerPreviewDraftDatesResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerPreviewDraftDatesResponseSuccess = (projectPlanningControllerPreviewDraftDatesResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerPreviewDraftDatesResponseError = (projectPlanningControllerPreviewDraftDatesResponse400 | projectPlanningControllerPreviewDraftDatesResponse401 | projectPlanningControllerPreviewDraftDatesResponse404) & {
  headers: Headers;
};

export type projectPlanningControllerPreviewDraftDatesResponse = (projectPlanningControllerPreviewDraftDatesResponseSuccess | projectPlanningControllerPreviewDraftDatesResponseError)

export const getProjectPlanningControllerPreviewDraftDatesUrl = (projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/projects/${projectId}/draft-dates/preview?${stringifiedParams}` : `/projects/${projectId}/draft-dates/preview`
}

/**
 * Computes the Spread Dates readout without writing anything: the start window (First/Last Start with lead time and buffer walked back in work days over the factory's shift calendar), weeks W, the draft/redrafting work order count N, the dated/fully-dated counts driving the overwrite confirmation and the Keep lead-time option, required throughput per week (N ÷ W), a week-grid summary of the shift pattern, and the area demand summary (sum of the area Standard Column over rows matching the partner's default unit; null when no row matches). Under Keep, limiting_lead_time identifies the first-in-sequence work order whose current or fallback lead limits Last Start, including for a closed window; it is null under Set. The window runs from the Spread Start Date (default: project start) to project complete. Powers the modal's live readout — re-fetched on every input change.
 * @summary Preview Spread Dates for a project (ENG-705/ENG-819)
 */
export const projectPlanningControllerPreviewDraftDates = async (projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options?: Parameters<typeof customFetch>[1]): Promise<projectPlanningControllerPreviewDraftDatesResponse> => {

  return customFetch<projectPlanningControllerPreviewDraftDatesResponse>(getProjectPlanningControllerPreviewDraftDatesUrl(projectId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProjectPlanningControllerPreviewDraftDatesQueryKey = (projectId: string,
    params?: ProjectPlanningControllerPreviewDraftDatesParams,) => {
    return [
    `/projects/${projectId}/draft-dates/preview`, ...(params ? [params] : [])
    ] as const;
    }


export const getProjectPlanningControllerPreviewDraftDatesQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError = void>(projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerPreviewDraftDatesQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>> = ({ signal }) => projectPlanningControllerPreviewDraftDates(projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectPlanningControllerPreviewDraftDatesQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>>
export type ProjectPlanningControllerPreviewDraftDatesQueryError = void


export function useProjectPlanningControllerPreviewDraftDates<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerPreviewDraftDates<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerPreviewDraftDates<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview Spread Dates for a project (ENG-705/ENG-819)
 */

export function useProjectPlanningControllerPreviewDraftDates<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectPlanningControllerPreviewDraftDatesQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Preview Spread Dates for a project (ENG-705/ENG-819)
 */
export const prefetchProjectPlanningControllerPreviewDraftDatesQuery = async <TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError = void>(
 queryClient: QueryClient, projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getProjectPlanningControllerPreviewDraftDatesQueryOptions(projectId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getProjectPlanningControllerPreviewDraftDatesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError = void>(projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerPreviewDraftDatesQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>> = ({ signal }) => projectPlanningControllerPreviewDraftDates(projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectPlanningControllerPreviewDraftDatesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>>
export type ProjectPlanningControllerPreviewDraftDatesSuspenseQueryError = void


export function useProjectPlanningControllerPreviewDraftDatesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerPreviewDraftDatesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerPreviewDraftDatesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview Spread Dates for a project (ENG-705/ENG-819)
 */

export function useProjectPlanningControllerPreviewDraftDatesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectPlanningControllerPreviewDraftDatesSuspenseQueryOptions(projectId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type projectPlanningControllerCommitDraftDatesResponse200 = {
  data: CommitDraftDatesResultDto
  status: 200
}

export type projectPlanningControllerCommitDraftDatesResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerCommitDraftDatesResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerCommitDraftDatesResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerCommitDraftDatesResponse409 = {
  data: void
  status: 409
}

export type projectPlanningControllerCommitDraftDatesResponseSuccess = (projectPlanningControllerCommitDraftDatesResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerCommitDraftDatesResponseError = (projectPlanningControllerCommitDraftDatesResponse400 | projectPlanningControllerCommitDraftDatesResponse401 | projectPlanningControllerCommitDraftDatesResponse404 | projectPlanningControllerCommitDraftDatesResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerCommitDraftDatesResponse = (projectPlanningControllerCommitDraftDatesResponseSuccess | projectPlanningControllerCommitDraftDatesResponseError)

export const getProjectPlanningControllerCommitDraftDatesUrl = (projectId: string,) => {




  return `/projects/${projectId}/draft-dates`
}

/**
 * Spreads Scheduled Start / Scheduled Complete timestamps evenly across the net working hours of the factory's shift calendar between the Spread Start Date (default: project start) and the project complete date, over the factory's draft/redrafting work orders in project-sequence order — started work is never touched. Under lead_time_mode 'keep', each work order holding both dates keeps its own lead time and the walk-back uses the longest lead in the draft. Everything is recomputed server-side at click time. Both timestamps are written in ONE transaction (all-or-nothing); the shift-refs trigger derives the slot references automatically. Only draft or redrafting projects can be drafted (409 otherwise). Work orders on other factories, or with no factory, are untouched.
 * @summary Spread Dates: write scheduled start/complete onto work orders (ENG-705/ENG-819)
 */
export const projectPlanningControllerCommitDraftDates = async (projectId: string,
    commitDraftDatesDto: CommitDraftDatesDto, options?: Parameters<typeof customFetch>[1]): Promise<projectPlanningControllerCommitDraftDatesResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<projectPlanningControllerCommitDraftDatesResponse>(getProjectPlanningControllerCommitDraftDatesUrl(projectId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(commitDraftDatesDto)
  }
);}





export const getProjectPlanningControllerCommitDraftDatesMutationKey = () => ['projectPlanningControllerCommitDraftDates'] as const;

export const getProjectPlanningControllerCommitDraftDatesMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerCommitDraftDates>>, TError,ProjectPlanningControllerCommitDraftDatesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerCommitDraftDates>>, TError,ProjectPlanningControllerCommitDraftDatesMutationVariables, TContext> => {

const mutationKey = getProjectPlanningControllerCommitDraftDatesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerCommitDraftDates>>, ProjectPlanningControllerCommitDraftDatesMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerCommitDraftDates(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerCommitDraftDatesMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerCommitDraftDates>>>
    export type ProjectPlanningControllerCommitDraftDatesMutationBody = CommitDraftDatesDto
    export type ProjectPlanningControllerCommitDraftDatesMutationError = void
    export type ProjectPlanningControllerCommitDraftDatesMutationVariables = {projectId: string;data: CommitDraftDatesDto}

    /**
 * @summary Spread Dates: write scheduled start/complete onto work orders (ENG-705/ENG-819)
 */
export const useProjectPlanningControllerCommitDraftDates = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerCommitDraftDates>>, TError,ProjectPlanningControllerCommitDraftDatesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerCommitDraftDates>>,
        TError,
        ProjectPlanningControllerCommitDraftDatesMutationVariables,
        TContext
      > => {
      return useMutation(getProjectPlanningControllerCommitDraftDatesMutationOptions(options), queryClient);
    }
    export type projectPlanningControllerPreviewPullDraftDatesResponse200 = {
  data: PullDraftDatesPreviewDto
  status: 200
}

export type projectPlanningControllerPreviewPullDraftDatesResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerPreviewPullDraftDatesResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerPreviewPullDraftDatesResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerPreviewPullDraftDatesResponseSuccess = (projectPlanningControllerPreviewPullDraftDatesResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerPreviewPullDraftDatesResponseError = (projectPlanningControllerPreviewPullDraftDatesResponse400 | projectPlanningControllerPreviewPullDraftDatesResponse401 | projectPlanningControllerPreviewPullDraftDatesResponse404) & {
  headers: Headers;
};

export type projectPlanningControllerPreviewPullDraftDatesResponse = (projectPlanningControllerPreviewPullDraftDatesResponseSuccess | projectPlanningControllerPreviewPullDraftDatesResponseError)

export const getProjectPlanningControllerPreviewPullDraftDatesUrl = (projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/projects/${projectId}/draft-dates/pull/preview?${stringifiedParams}` : `/projects/${projectId}/draft-dates/pull/preview`
}

/**
 * Computes the Pull Dates readout without writing anything. Each draft/redrafting work order works back from its own value in the chosen driving date column — buffer work days back to a scheduled complete, lead time back to a scheduled start, on the factory's shift calendar. Work orders with no driving value are listed as skipped and will be left untouched. The demand readout window is clamped to today on the factory's clock (window start = max(project start, today), end = max(project complete, today)); when project complete is on or before today, the window is closed and the demand numbers are null — drafting itself is never blocked by the window.
 * @summary Preview Pull Dates for a project (ENG-819)
 */
export const projectPlanningControllerPreviewPullDraftDates = async (projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options?: Parameters<typeof customFetch>[1]): Promise<projectPlanningControllerPreviewPullDraftDatesResponse> => {

  return customFetch<projectPlanningControllerPreviewPullDraftDatesResponse>(getProjectPlanningControllerPreviewPullDraftDatesUrl(projectId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProjectPlanningControllerPreviewPullDraftDatesQueryKey = (projectId: string,
    params?: ProjectPlanningControllerPreviewPullDraftDatesParams,) => {
    return [
    `/projects/${projectId}/draft-dates/pull/preview`, ...(params ? [params] : [])
    ] as const;
    }


export const getProjectPlanningControllerPreviewPullDraftDatesQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError = void>(projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerPreviewPullDraftDatesQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>> = ({ signal }) => projectPlanningControllerPreviewPullDraftDates(projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectPlanningControllerPreviewPullDraftDatesQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>>
export type ProjectPlanningControllerPreviewPullDraftDatesQueryError = void


export function useProjectPlanningControllerPreviewPullDraftDates<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerPreviewPullDraftDates<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerPreviewPullDraftDates<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview Pull Dates for a project (ENG-819)
 */

export function useProjectPlanningControllerPreviewPullDraftDates<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectPlanningControllerPreviewPullDraftDatesQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Preview Pull Dates for a project (ENG-819)
 */
export const prefetchProjectPlanningControllerPreviewPullDraftDatesQuery = async <TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError = void>(
 queryClient: QueryClient, projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getProjectPlanningControllerPreviewPullDraftDatesQueryOptions(projectId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getProjectPlanningControllerPreviewPullDraftDatesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError = void>(projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerPreviewPullDraftDatesQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>> = ({ signal }) => projectPlanningControllerPreviewPullDraftDates(projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectPlanningControllerPreviewPullDraftDatesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>>
export type ProjectPlanningControllerPreviewPullDraftDatesSuspenseQueryError = void


export function useProjectPlanningControllerPreviewPullDraftDatesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerPreviewPullDraftDatesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectPlanningControllerPreviewPullDraftDatesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview Pull Dates for a project (ENG-819)
 */

export function useProjectPlanningControllerPreviewPullDraftDatesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectPlanningControllerPreviewPullDraftDatesSuspenseQueryOptions(projectId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type projectPlanningControllerCommitPullDraftDatesResponse200 = {
  data: CommitPullDraftDatesResultDto
  status: 200
}

export type projectPlanningControllerCommitPullDraftDatesResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerCommitPullDraftDatesResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerCommitPullDraftDatesResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerCommitPullDraftDatesResponse409 = {
  data: void
  status: 409
}

export type projectPlanningControllerCommitPullDraftDatesResponseSuccess = (projectPlanningControllerCommitPullDraftDatesResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerCommitPullDraftDatesResponseError = (projectPlanningControllerCommitPullDraftDatesResponse400 | projectPlanningControllerCommitPullDraftDatesResponse401 | projectPlanningControllerCommitPullDraftDatesResponse404 | projectPlanningControllerCommitPullDraftDatesResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerCommitPullDraftDatesResponse = (projectPlanningControllerCommitPullDraftDatesResponseSuccess | projectPlanningControllerCommitPullDraftDatesResponseError)

export const getProjectPlanningControllerCommitPullDraftDatesUrl = (projectId: string,) => {




  return `/projects/${projectId}/draft-dates/pull`
}

/**
 * For each draft/redrafting work order with a value in the driving date column: scheduled complete = that value walked back by the buffer in work days, scheduled start = the complete walked back by the production lead time ('set' flat value, or each work order's own kept lead under 'keep'), both on the factory's shift calendar. Work orders missing the driving value are skipped and untouched — skips are recomputed server-side at click time. All written rows commit in ONE transaction (all-or-nothing); a draft where every work order is skipped writes nothing and succeeds with updated_count 0. Only draft or redrafting projects can be drafted (409 otherwise).
 * @summary Pull Dates: write scheduled start/complete walked back from a driving column (ENG-819)
 */
export const projectPlanningControllerCommitPullDraftDates = async (projectId: string,
    commitPullDraftDatesDto: CommitPullDraftDatesDto, options?: Parameters<typeof customFetch>[1]): Promise<projectPlanningControllerCommitPullDraftDatesResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<projectPlanningControllerCommitPullDraftDatesResponse>(getProjectPlanningControllerCommitPullDraftDatesUrl(projectId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(commitPullDraftDatesDto)
  }
);}





export const getProjectPlanningControllerCommitPullDraftDatesMutationKey = () => ['projectPlanningControllerCommitPullDraftDates'] as const;

export const getProjectPlanningControllerCommitPullDraftDatesMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerCommitPullDraftDates>>, TError,ProjectPlanningControllerCommitPullDraftDatesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerCommitPullDraftDates>>, TError,ProjectPlanningControllerCommitPullDraftDatesMutationVariables, TContext> => {

const mutationKey = getProjectPlanningControllerCommitPullDraftDatesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerCommitPullDraftDates>>, ProjectPlanningControllerCommitPullDraftDatesMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerCommitPullDraftDates(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerCommitPullDraftDatesMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerCommitPullDraftDates>>>
    export type ProjectPlanningControllerCommitPullDraftDatesMutationBody = CommitPullDraftDatesDto
    export type ProjectPlanningControllerCommitPullDraftDatesMutationError = void
    export type ProjectPlanningControllerCommitPullDraftDatesMutationVariables = {projectId: string;data: CommitPullDraftDatesDto}

    /**
 * @summary Pull Dates: write scheduled start/complete walked back from a driving column (ENG-819)
 */
export const useProjectPlanningControllerCommitPullDraftDates = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerCommitPullDraftDates>>, TError,ProjectPlanningControllerCommitPullDraftDatesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerCommitPullDraftDates>>,
        TError,
        ProjectPlanningControllerCommitPullDraftDatesMutationVariables,
        TContext
      > => {
      return useMutation(getProjectPlanningControllerCommitPullDraftDatesMutationOptions(options), queryClient);
    }
    export type projectPlanningControllerPreviewManufacturingSequenceResponse200 = {
  data: ProjectManufacturingSequencePreviewDto
  status: 200
}

export type projectPlanningControllerPreviewManufacturingSequenceResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerPreviewManufacturingSequenceResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerPreviewManufacturingSequenceResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerPreviewManufacturingSequenceResponse409 = {
  data: void
  status: 409
}

export type projectPlanningControllerPreviewManufacturingSequenceResponseSuccess = (projectPlanningControllerPreviewManufacturingSequenceResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerPreviewManufacturingSequenceResponseError = (projectPlanningControllerPreviewManufacturingSequenceResponse400 | projectPlanningControllerPreviewManufacturingSequenceResponse401 | projectPlanningControllerPreviewManufacturingSequenceResponse404 | projectPlanningControllerPreviewManufacturingSequenceResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerPreviewManufacturingSequenceResponse = (projectPlanningControllerPreviewManufacturingSequenceResponseSuccess | projectPlanningControllerPreviewManufacturingSequenceResponseError)

export const getProjectPlanningControllerPreviewManufacturingSequenceUrl = (projectId: string,) => {




  return `/projects/${projectId}/manufacturing-sequence/preview`
}

/**
 * Runs the same numbering as the update — Complete / In Process first by actual start time (ties keep their existing relative order), then the submitted order for everything else, then archived work orders — without locking or writing anything. Returns the first and last work orders of the resulting sequence, the counts behind them, and a `digest` to send back as the update's `expected_digest`.
 * @summary Preview the Project Manufacturing Sequence an update would write (ENG-926)
 */
export const projectPlanningControllerPreviewManufacturingSequence = async (projectId: string,
    previewProjectManufacturingSequenceDto: PreviewProjectManufacturingSequenceDto, options?: Parameters<typeof customFetch>[1]): Promise<projectPlanningControllerPreviewManufacturingSequenceResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<projectPlanningControllerPreviewManufacturingSequenceResponse>(getProjectPlanningControllerPreviewManufacturingSequenceUrl(projectId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(previewProjectManufacturingSequenceDto)
  }
);}





export const getProjectPlanningControllerPreviewManufacturingSequenceMutationKey = () => ['projectPlanningControllerPreviewManufacturingSequence'] as const;

export const getProjectPlanningControllerPreviewManufacturingSequenceMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewManufacturingSequence>>, TError,ProjectPlanningControllerPreviewManufacturingSequenceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewManufacturingSequence>>, TError,ProjectPlanningControllerPreviewManufacturingSequenceMutationVariables, TContext> => {

const mutationKey = getProjectPlanningControllerPreviewManufacturingSequenceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerPreviewManufacturingSequence>>, ProjectPlanningControllerPreviewManufacturingSequenceMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerPreviewManufacturingSequence(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerPreviewManufacturingSequenceMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerPreviewManufacturingSequence>>>
    export type ProjectPlanningControllerPreviewManufacturingSequenceMutationBody = PreviewProjectManufacturingSequenceDto
    export type ProjectPlanningControllerPreviewManufacturingSequenceMutationError = void
    export type ProjectPlanningControllerPreviewManufacturingSequenceMutationVariables = {projectId: string;data: PreviewProjectManufacturingSequenceDto}

    /**
 * @summary Preview the Project Manufacturing Sequence an update would write (ENG-926)
 */
export const useProjectPlanningControllerPreviewManufacturingSequence = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewManufacturingSequence>>, TError,ProjectPlanningControllerPreviewManufacturingSequenceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerPreviewManufacturingSequence>>,
        TError,
        ProjectPlanningControllerPreviewManufacturingSequenceMutationVariables,
        TContext
      > => {
      return useMutation(getProjectPlanningControllerPreviewManufacturingSequenceMutationOptions(options), queryClient);
    }
    export type projectPlanningControllerUpdateManufacturingSequenceResponse200 = {
  data: ProjectManufacturingSequenceResultDto
  status: 200
}

export type projectPlanningControllerUpdateManufacturingSequenceResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerUpdateManufacturingSequenceResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerUpdateManufacturingSequenceResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerUpdateManufacturingSequenceResponse409 = {
  data: void
  status: 409
}

export type projectPlanningControllerUpdateManufacturingSequenceResponseSuccess = (projectPlanningControllerUpdateManufacturingSequenceResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerUpdateManufacturingSequenceResponseError = (projectPlanningControllerUpdateManufacturingSequenceResponse400 | projectPlanningControllerUpdateManufacturingSequenceResponse401 | projectPlanningControllerUpdateManufacturingSequenceResponse404 | projectPlanningControllerUpdateManufacturingSequenceResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerUpdateManufacturingSequenceResponse = (projectPlanningControllerUpdateManufacturingSequenceResponseSuccess | projectPlanningControllerUpdateManufacturingSequenceResponseError)

export const getProjectPlanningControllerUpdateManufacturingSequenceUrl = (projectId: string,) => {




  return `/projects/${projectId}/manufacturing-sequence`
}

/**
 * Renumbers EVERY work order of the project 1..N in one transaction: Complete / In Process take the opening positions by actual start time (ties keep their existing relative order), the submitted order fills the rest, and archived work orders trail the active range so the project still holds a complete sequence. Available in every project status, and the only action that changes the sequence — drafted dates, schedules and Manufacturing Sequence Numbers are untouched. Send the full active set: filters narrow what the planner looks at, never what gets numbered.
 * @summary Update the Project Manufacturing Sequence (ENG-926)
 */
export const projectPlanningControllerUpdateManufacturingSequence = async (projectId: string,
    updateProjectManufacturingSequenceDto: UpdateProjectManufacturingSequenceDto, options?: Parameters<typeof customFetch>[1]): Promise<projectPlanningControllerUpdateManufacturingSequenceResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<projectPlanningControllerUpdateManufacturingSequenceResponse>(getProjectPlanningControllerUpdateManufacturingSequenceUrl(projectId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateProjectManufacturingSequenceDto)
  }
);}





export const getProjectPlanningControllerUpdateManufacturingSequenceMutationKey = () => ['projectPlanningControllerUpdateManufacturingSequence'] as const;

export const getProjectPlanningControllerUpdateManufacturingSequenceMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUpdateManufacturingSequence>>, TError,ProjectPlanningControllerUpdateManufacturingSequenceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUpdateManufacturingSequence>>, TError,ProjectPlanningControllerUpdateManufacturingSequenceMutationVariables, TContext> => {

const mutationKey = getProjectPlanningControllerUpdateManufacturingSequenceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerUpdateManufacturingSequence>>, ProjectPlanningControllerUpdateManufacturingSequenceMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerUpdateManufacturingSequence(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerUpdateManufacturingSequenceMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerUpdateManufacturingSequence>>>
    export type ProjectPlanningControllerUpdateManufacturingSequenceMutationBody = UpdateProjectManufacturingSequenceDto
    export type ProjectPlanningControllerUpdateManufacturingSequenceMutationError = void
    export type ProjectPlanningControllerUpdateManufacturingSequenceMutationVariables = {projectId: string;data: UpdateProjectManufacturingSequenceDto}

    /**
 * @summary Update the Project Manufacturing Sequence (ENG-926)
 */
export const useProjectPlanningControllerUpdateManufacturingSequence = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUpdateManufacturingSequence>>, TError,ProjectPlanningControllerUpdateManufacturingSequenceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerUpdateManufacturingSequence>>,
        TError,
        ProjectPlanningControllerUpdateManufacturingSequenceMutationVariables,
        TContext
      > => {
      return useMutation(getProjectPlanningControllerUpdateManufacturingSequenceMutationOptions(options), queryClient);
    }
    export type projectPlanningControllerBatchAddWorkOrdersResponse201 = {
  data: ProjectWorkOrderDetailDto[]
  status: 201
}

export type projectPlanningControllerBatchAddWorkOrdersResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerBatchAddWorkOrdersResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerBatchAddWorkOrdersResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerBatchAddWorkOrdersResponse409 = {
  data: void
  status: 409
}

export type projectPlanningControllerBatchAddWorkOrdersResponseSuccess = (projectPlanningControllerBatchAddWorkOrdersResponse201) & {
  headers: Headers;
};
export type projectPlanningControllerBatchAddWorkOrdersResponseError = (projectPlanningControllerBatchAddWorkOrdersResponse400 | projectPlanningControllerBatchAddWorkOrdersResponse401 | projectPlanningControllerBatchAddWorkOrdersResponse404 | projectPlanningControllerBatchAddWorkOrdersResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerBatchAddWorkOrdersResponse = (projectPlanningControllerBatchAddWorkOrdersResponseSuccess | projectPlanningControllerBatchAddWorkOrdersResponseError)

export const getProjectPlanningControllerBatchAddWorkOrdersUrl = (projectId: string,) => {




  return `/projects/${projectId}/work-orders`
}

/**
 * Creates the specified number of work order rows on a draft project, each sharing a Product seeded with the supplied Product Type. When the partner has exactly one factory, it is pre-selected on every new work order. Returns all work orders on the project.
 * @summary Batch add work orders to a project
 */
export const projectPlanningControllerBatchAddWorkOrders = async (projectId: string,
    batchAddWorkOrdersDto: BatchAddWorkOrdersDto, options?: Parameters<typeof customFetch>[1]): Promise<projectPlanningControllerBatchAddWorkOrdersResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<projectPlanningControllerBatchAddWorkOrdersResponse>(getProjectPlanningControllerBatchAddWorkOrdersUrl(projectId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(batchAddWorkOrdersDto)
  }
);}





export const getProjectPlanningControllerBatchAddWorkOrdersMutationKey = () => ['projectPlanningControllerBatchAddWorkOrders'] as const;

export const getProjectPlanningControllerBatchAddWorkOrdersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchAddWorkOrders>>, TError,ProjectPlanningControllerBatchAddWorkOrdersMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchAddWorkOrders>>, TError,ProjectPlanningControllerBatchAddWorkOrdersMutationVariables, TContext> => {

const mutationKey = getProjectPlanningControllerBatchAddWorkOrdersMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerBatchAddWorkOrders>>, ProjectPlanningControllerBatchAddWorkOrdersMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerBatchAddWorkOrders(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerBatchAddWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerBatchAddWorkOrders>>>
    export type ProjectPlanningControllerBatchAddWorkOrdersMutationBody = BatchAddWorkOrdersDto
    export type ProjectPlanningControllerBatchAddWorkOrdersMutationError = void
    export type ProjectPlanningControllerBatchAddWorkOrdersMutationVariables = {projectId: string;data: BatchAddWorkOrdersDto}

    /**
 * @summary Batch add work orders to a project
 */
export const useProjectPlanningControllerBatchAddWorkOrders = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchAddWorkOrders>>, TError,ProjectPlanningControllerBatchAddWorkOrdersMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerBatchAddWorkOrders>>,
        TError,
        ProjectPlanningControllerBatchAddWorkOrdersMutationVariables,
        TContext
      > => {
      return useMutation(getProjectPlanningControllerBatchAddWorkOrdersMutationOptions(options), queryClient);
    }
    export type projectPlanningControllerBatchRemoveWorkOrdersResponse200 = {
  data: ProjectWorkOrderDetailDto[]
  status: 200
}

export type projectPlanningControllerBatchRemoveWorkOrdersResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerBatchRemoveWorkOrdersResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerBatchRemoveWorkOrdersResponse409 = {
  data: void
  status: 409
}

export type projectPlanningControllerBatchRemoveWorkOrdersResponseSuccess = (projectPlanningControllerBatchRemoveWorkOrdersResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerBatchRemoveWorkOrdersResponseError = (projectPlanningControllerBatchRemoveWorkOrdersResponse401 | projectPlanningControllerBatchRemoveWorkOrdersResponse404 | projectPlanningControllerBatchRemoveWorkOrdersResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerBatchRemoveWorkOrdersResponse = (projectPlanningControllerBatchRemoveWorkOrdersResponseSuccess | projectPlanningControllerBatchRemoveWorkOrdersResponseError)

export const getProjectPlanningControllerBatchRemoveWorkOrdersUrl = (projectId: string,) => {




  return `/projects/${projectId}/work-orders`
}

/**
 * Deletes the specified work orders and their associated products from a draft project. Returns remaining work orders.
 * @summary Batch remove work orders from a project
 */
export const projectPlanningControllerBatchRemoveWorkOrders = async (projectId: string,
    batchRemoveWorkOrdersDto: BatchRemoveWorkOrdersDto, options?: Parameters<typeof customFetch>[1]): Promise<projectPlanningControllerBatchRemoveWorkOrdersResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<projectPlanningControllerBatchRemoveWorkOrdersResponse>(getProjectPlanningControllerBatchRemoveWorkOrdersUrl(projectId),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(batchRemoveWorkOrdersDto)
  }
);}





export const getProjectPlanningControllerBatchRemoveWorkOrdersMutationKey = () => ['projectPlanningControllerBatchRemoveWorkOrders'] as const;

export const getProjectPlanningControllerBatchRemoveWorkOrdersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchRemoveWorkOrders>>, TError,ProjectPlanningControllerBatchRemoveWorkOrdersMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchRemoveWorkOrders>>, TError,ProjectPlanningControllerBatchRemoveWorkOrdersMutationVariables, TContext> => {

const mutationKey = getProjectPlanningControllerBatchRemoveWorkOrdersMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerBatchRemoveWorkOrders>>, ProjectPlanningControllerBatchRemoveWorkOrdersMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerBatchRemoveWorkOrders(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerBatchRemoveWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerBatchRemoveWorkOrders>>>
    export type ProjectPlanningControllerBatchRemoveWorkOrdersMutationBody = BatchRemoveWorkOrdersDto
    export type ProjectPlanningControllerBatchRemoveWorkOrdersMutationError = void
    export type ProjectPlanningControllerBatchRemoveWorkOrdersMutationVariables = {projectId: string;data: BatchRemoveWorkOrdersDto}

    /**
 * @summary Batch remove work orders from a project
 */
export const useProjectPlanningControllerBatchRemoveWorkOrders = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchRemoveWorkOrders>>, TError,ProjectPlanningControllerBatchRemoveWorkOrdersMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerBatchRemoveWorkOrders>>,
        TError,
        ProjectPlanningControllerBatchRemoveWorkOrdersMutationVariables,
        TContext
      > => {
      return useMutation(getProjectPlanningControllerBatchRemoveWorkOrdersMutationOptions(options), queryClient);
    }
    export type projectPlanningControllerBatchUpdateWorkOrdersResponse200 = {
  data: ProjectWorkOrderDetailDto[]
  status: 200
}

export type projectPlanningControllerBatchUpdateWorkOrdersResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerBatchUpdateWorkOrdersResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerBatchUpdateWorkOrdersResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerBatchUpdateWorkOrdersResponse409 = {
  data: void
  status: 409
}

export type projectPlanningControllerBatchUpdateWorkOrdersResponseSuccess = (projectPlanningControllerBatchUpdateWorkOrdersResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerBatchUpdateWorkOrdersResponseError = (projectPlanningControllerBatchUpdateWorkOrdersResponse400 | projectPlanningControllerBatchUpdateWorkOrdersResponse401 | projectPlanningControllerBatchUpdateWorkOrdersResponse404 | projectPlanningControllerBatchUpdateWorkOrdersResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerBatchUpdateWorkOrdersResponse = (projectPlanningControllerBatchUpdateWorkOrdersResponseSuccess | projectPlanningControllerBatchUpdateWorkOrdersResponseError)

export const getProjectPlanningControllerBatchUpdateWorkOrdersUrl = (projectId: string,) => {




  return `/projects/${projectId}/work-orders/batch`
}

/**
 * Applies an array of cell-level updates to work orders on a draft project. Each update targets a work order field (scalar) or a container selection (UUID field). Recalculates Product Codes after container changes.
 * @summary Batch update work order cells
 */
export const projectPlanningControllerBatchUpdateWorkOrders = async (projectId: string,
    batchUpdateWorkOrdersDto: BatchUpdateWorkOrdersDto, options?: Parameters<typeof customFetch>[1]): Promise<projectPlanningControllerBatchUpdateWorkOrdersResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<projectPlanningControllerBatchUpdateWorkOrdersResponse>(getProjectPlanningControllerBatchUpdateWorkOrdersUrl(projectId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(batchUpdateWorkOrdersDto)
  }
);}





export const getProjectPlanningControllerBatchUpdateWorkOrdersMutationKey = () => ['projectPlanningControllerBatchUpdateWorkOrders'] as const;

export const getProjectPlanningControllerBatchUpdateWorkOrdersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchUpdateWorkOrders>>, TError,ProjectPlanningControllerBatchUpdateWorkOrdersMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchUpdateWorkOrders>>, TError,ProjectPlanningControllerBatchUpdateWorkOrdersMutationVariables, TContext> => {

const mutationKey = getProjectPlanningControllerBatchUpdateWorkOrdersMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerBatchUpdateWorkOrders>>, ProjectPlanningControllerBatchUpdateWorkOrdersMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerBatchUpdateWorkOrders(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerBatchUpdateWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerBatchUpdateWorkOrders>>>
    export type ProjectPlanningControllerBatchUpdateWorkOrdersMutationBody = BatchUpdateWorkOrdersDto
    export type ProjectPlanningControllerBatchUpdateWorkOrdersMutationError = void
    export type ProjectPlanningControllerBatchUpdateWorkOrdersMutationVariables = {projectId: string;data: BatchUpdateWorkOrdersDto}

    /**
 * @summary Batch update work order cells
 */
export const useProjectPlanningControllerBatchUpdateWorkOrders = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchUpdateWorkOrders>>, TError,ProjectPlanningControllerBatchUpdateWorkOrdersMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerBatchUpdateWorkOrders>>,
        TError,
        ProjectPlanningControllerBatchUpdateWorkOrdersMutationVariables,
        TContext
      > => {
      return useMutation(getProjectPlanningControllerBatchUpdateWorkOrdersMutationOptions(options), queryClient);
    }
    export type projectPlanningControllerArchiveWorkOrdersResponse200 = {
  data: ArchiveWorkOrdersResultDto
  status: 200
}

export type projectPlanningControllerArchiveWorkOrdersResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerArchiveWorkOrdersResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerArchiveWorkOrdersResponse409 = {
  data: void
  status: 409
}

export type projectPlanningControllerArchiveWorkOrdersResponseSuccess = (projectPlanningControllerArchiveWorkOrdersResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerArchiveWorkOrdersResponseError = (projectPlanningControllerArchiveWorkOrdersResponse401 | projectPlanningControllerArchiveWorkOrdersResponse404 | projectPlanningControllerArchiveWorkOrdersResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerArchiveWorkOrdersResponse = (projectPlanningControllerArchiveWorkOrdersResponseSuccess | projectPlanningControllerArchiveWorkOrdersResponseError)

export const getProjectPlanningControllerArchiveWorkOrdersUrl = (projectId: string,) => {




  return `/projects/${projectId}/work-orders/archive`
}

/**
 * Archives the submitted work orders that are in `scheduled` or `redrafting` status, removing them from active planning views without deleting any data. Work orders in any other status (in_progress, complete, draft, already archived) are left untouched and returned in `skipped`. Each archive is recorded in the audit trail.
 * @summary Archive work orders on a project
 */
export const projectPlanningControllerArchiveWorkOrders = async (projectId: string,
    archiveWorkOrdersDto: ArchiveWorkOrdersDto, options?: Parameters<typeof customFetch>[1]): Promise<projectPlanningControllerArchiveWorkOrdersResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<projectPlanningControllerArchiveWorkOrdersResponse>(getProjectPlanningControllerArchiveWorkOrdersUrl(projectId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(archiveWorkOrdersDto)
  }
);}





export const getProjectPlanningControllerArchiveWorkOrdersMutationKey = () => ['projectPlanningControllerArchiveWorkOrders'] as const;

export const getProjectPlanningControllerArchiveWorkOrdersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerArchiveWorkOrders>>, TError,ProjectPlanningControllerArchiveWorkOrdersMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerArchiveWorkOrders>>, TError,ProjectPlanningControllerArchiveWorkOrdersMutationVariables, TContext> => {

const mutationKey = getProjectPlanningControllerArchiveWorkOrdersMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerArchiveWorkOrders>>, ProjectPlanningControllerArchiveWorkOrdersMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerArchiveWorkOrders(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerArchiveWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerArchiveWorkOrders>>>
    export type ProjectPlanningControllerArchiveWorkOrdersMutationBody = ArchiveWorkOrdersDto
    export type ProjectPlanningControllerArchiveWorkOrdersMutationError = void
    export type ProjectPlanningControllerArchiveWorkOrdersMutationVariables = {projectId: string;data: ArchiveWorkOrdersDto}

    /**
 * @summary Archive work orders on a project
 */
export const useProjectPlanningControllerArchiveWorkOrders = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerArchiveWorkOrders>>, TError,ProjectPlanningControllerArchiveWorkOrdersMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerArchiveWorkOrders>>,
        TError,
        ProjectPlanningControllerArchiveWorkOrdersMutationVariables,
        TContext
      > => {
      return useMutation(getProjectPlanningControllerArchiveWorkOrdersMutationOptions(options), queryClient);
    }
    export type projectPlanningControllerUnarchiveWorkOrdersResponse200 = {
  data: UnarchiveWorkOrdersResultDto
  status: 200
}

export type projectPlanningControllerUnarchiveWorkOrdersResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerUnarchiveWorkOrdersResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerUnarchiveWorkOrdersResponse409 = {
  data: void
  status: 409
}

export type projectPlanningControllerUnarchiveWorkOrdersResponseSuccess = (projectPlanningControllerUnarchiveWorkOrdersResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerUnarchiveWorkOrdersResponseError = (projectPlanningControllerUnarchiveWorkOrdersResponse401 | projectPlanningControllerUnarchiveWorkOrdersResponse404 | projectPlanningControllerUnarchiveWorkOrdersResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerUnarchiveWorkOrdersResponse = (projectPlanningControllerUnarchiveWorkOrdersResponseSuccess | projectPlanningControllerUnarchiveWorkOrdersResponseError)

export const getProjectPlanningControllerUnarchiveWorkOrdersUrl = (projectId: string,) => {




  return `/projects/${projectId}/work-orders/unarchive`
}

/**
 * Restores the submitted archived work orders to the active view, recomputing their lifecycle status from start/complete dates and Run Sheet assignment. Work orders that are not currently archived are returned in `skipped`. Each unarchive is recorded in the audit trail.
 * @summary Unarchive work orders on a project
 */
export const projectPlanningControllerUnarchiveWorkOrders = async (projectId: string,
    unarchiveWorkOrdersDto: UnarchiveWorkOrdersDto, options?: Parameters<typeof customFetch>[1]): Promise<projectPlanningControllerUnarchiveWorkOrdersResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<projectPlanningControllerUnarchiveWorkOrdersResponse>(getProjectPlanningControllerUnarchiveWorkOrdersUrl(projectId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(unarchiveWorkOrdersDto)
  }
);}





export const getProjectPlanningControllerUnarchiveWorkOrdersMutationKey = () => ['projectPlanningControllerUnarchiveWorkOrders'] as const;

export const getProjectPlanningControllerUnarchiveWorkOrdersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUnarchiveWorkOrders>>, TError,ProjectPlanningControllerUnarchiveWorkOrdersMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUnarchiveWorkOrders>>, TError,ProjectPlanningControllerUnarchiveWorkOrdersMutationVariables, TContext> => {

const mutationKey = getProjectPlanningControllerUnarchiveWorkOrdersMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerUnarchiveWorkOrders>>, ProjectPlanningControllerUnarchiveWorkOrdersMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerUnarchiveWorkOrders(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerUnarchiveWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerUnarchiveWorkOrders>>>
    export type ProjectPlanningControllerUnarchiveWorkOrdersMutationBody = UnarchiveWorkOrdersDto
    export type ProjectPlanningControllerUnarchiveWorkOrdersMutationError = void
    export type ProjectPlanningControllerUnarchiveWorkOrdersMutationVariables = {projectId: string;data: UnarchiveWorkOrdersDto}

    /**
 * @summary Unarchive work orders on a project
 */
export const useProjectPlanningControllerUnarchiveWorkOrders = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUnarchiveWorkOrders>>, TError,ProjectPlanningControllerUnarchiveWorkOrdersMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerUnarchiveWorkOrders>>,
        TError,
        ProjectPlanningControllerUnarchiveWorkOrdersMutationVariables,
        TContext
      > => {
      return useMutation(getProjectPlanningControllerUnarchiveWorkOrdersMutationOptions(options), queryClient);
    }
